import { render, staticRenderFns } from "./NewTripGoToApp.vue?vue&type=template&id=ba59cbd4&"
import script from "./NewTripGoToApp.vue?vue&type=script&lang=js&"
export * from "./NewTripGoToApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports